var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-fixed-height btn-bg-white btn-text-dark-50 btn-icon-primary font-weight-bolder px-5",attrs:{"href":_vm.frontendUrl + _vm.link,"target":"_blank"}},[_vm._m(0),_vm._v("\n    "+_vm._s(_vm.__('general.view_on_youbuyda'))+"\n")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"svg-icon svg-icon-md"},[_c('i',{staticClass:"fas fa-eye"})])
}]

export { render, staticRenderFns }